import React, {useEffect, useState} from 'react';
import {Card, List} from 'antd';
import {useDispatch, useSelector} from 'react-redux';
import * as actions from 'src/setup/redux/global/Actions';

const Receiver = () => {
  const dispatch = useDispatch();
  const messages = useSelector((state) => state.global.messages);

  const renderListItem = (item) => (
    <List.Item>
      <List.Item.Meta title={item.topic} description={item.message} />
      <div>
        {item.time}
      </div>
    </List.Item>
  );

  return (
    <>
      <div className='card-header'>
        <h3 className='card-title align-items-start flex-column m-0'>
          <span className='card-label fw-bold text-gray-900'>Received</span>
        </h3>
        <div className='card-toolbar m-0'>
          <button
            className='btn btn-sm btn-danger py-2 me-2'
            onClick={() => {
              dispatch(actions.clearMessages());
            }}
          >
            <span>
              <i className='fas fa-trash me-2'></i>
              <span className=''>Delete All</span>
            </span>
          </button>
        </div>
      </div>
      <div className='card-body p-0'>
        <div className='hover-scroll-y h-300px px-5'>
          <List size='small' bordered dataSource={messages} renderItem={renderListItem} />
        </div>
      </div>
    </>
  );
};

export default Receiver;
